import React, { useState, useEffect } from 'react'
import { FaRegFileAudio, FaRegAddressCard, FaRegFilePdf, FaRegFileVideo } from 'react-icons/fa'
import { IoMdDownload } from 'react-icons/io'
import { GrDocumentZip } from 'react-icons/gr'
import Moment from 'moment'

import { isImageType, isVideoType } from 'utils/checkFileType'
import Lang from 'Lang/General'

const Message = props => {
  const [messageParticipant, setMessageParticipant] = useState({})

  useEffect(() => {
    setMessageParticipant(props.selectedDialogue.dialogue_participants[props.message.dialogue_participants_id])
  }, [props.message])

  useEffect(() => {
    if (!props.isInternalDialogue && props.lastMessageId === props.message.id) {
      const resizeObserver = new ResizeObserver(entries => {
        for (let _ of entries) {
          let messagesContainer = window.document.getElementById('dialogue-container')

          if (!props.searchActive) {
            messagesContainer.scrollTo({
              behavior: 'smooth',
              top: messagesContainer.scrollHeight
            })

            if (!props.isInternalDialogue &&
              props.selectedDialogue.last_read_message_id !== props.message.id
            ) {
              props.updateLastRead({
                dialogue_id: props.selectedDialogue.encrypted_id,
                last_read_message_id: props.message.id
              })
            }
          }
        }
      })

      resizeObserver.observe(window.document.getElementById('message-container'))

      return () => resizeObserver.disconnect()
    }
  }, [props.lastMessageId])

  useEffect(() => {
    if (props.isInternalDialogue && props.lastInternalMsgId === props.message.id) {
      const resizeObserver = new ResizeObserver(entries => {
        for (let _ of entries) {
          let messagesContainer = window.document.getElementById('internal-dialogue-container')

          messagesContainer.scrollTo({
            behavior: 'smooth',
            top: messagesContainer.scrollHeight
          })
        }
      })

      resizeObserver.observe(window.document.getElementById('internal-message-container'))

      return () => resizeObserver.disconnect()
    }
  }, [props.lastMessageId, props.lastInternalMsgId])

  return (
    <div
      id={`dialogue-message-${props.message.id}`}
      className='my-1'
      style={{
        display: "flex",
        flexDirection: "row",
        width: !props.isInternalDialogue ? "100%" : 'unset',
        justifyContent: messageParticipant.user_id === 0
          ? "flex-start"
          : "flex-end"
      }} >
      <div
        style={{
          ... !props.isInternalDialogue ? {
            display: "flex",
            flexDirection: "column",
            maxWidth: "60%"
          } : {
          }
        }} >
        {
          props.isInternalDialogue && (
            <div className="d-flex" style={{ paddingLeft: 10 }}>
              <small>
                <span style={{ whiteSpace: "nowrap" }} >
                  {Moment(props.message.created_at).format('DD.MM.YYYY')}
                </span>
                <span> </span>
                <span style={{ whiteSpace: "nowrap" }} >
                  {Moment(props.message.created_at).format('h:mm A')}
                </span>
              </small>
              <small>
                {` - `}
                {messageParticipant.name}
              </small>
            </div>
          )
        }
        {
          !props.isInternalDialogue &&
          messageParticipant.user_id > 0 && (
            <span style={{ fontSize: "70%", textAlign: "right" }} >
              {messageParticipant.name}
              { 
                props.message.is_internal && (
                  <span style={{ color: '#dc3545' }} > ({ Lang['NOTE_IS_ONLY_VISIBLE_INTERNALLY'][props.selectedLanguage] })</span> 
                )
              }
            </span>
          )
        }
        <div
          className='p-2'
          style={{
            borderRadius: messageParticipant.user_id === 0
              ? '20px 20px 20px 0px'
              : '20px 20px 0px 20px',
            ... !props.isInternalDialogue ? {
              display: "flex",
              flexDirection: "column",
              color: props.message.is_internal ? 'white' : 'black',
              background: props.message.is_internal
                ? "#dc3545"
                : messageParticipant.user_id === 0
                  ? "#e5eddd"
                  : "#d6e2fd"
            } : {
            }
          }} >
          {
            props.message.attachments?.[0] &&
            props.message.attachments.map(attachment => {
              if (isImageType(attachment.file_type)) {
                return (
                  <button
                    style={{
                      border: "none",
                      background: "none",
                      padding: "0",
                      lineHeight: "1"
                    }}
                    onClick={() => (window.location.href = attachment.original_url)} >
                    <img
                      className='mb-2'
                      src={attachment.thumb_url}
                      style={{ objectFit: "contain" }}
                    />
                  </button>
                )
              } else {
                return (
                  <button
                    style={{
                      border: "none",
                      background: "none",
                      padding: "0",
                      lineHeight: "1"
                    }}
                    onClick={() => (window.location.href = attachment.original_url)}
                    className='d-flex flex-row flex-nowrap align-items-center mb-2' >
                    <div className='mr-2' >
                      {
                        attachment.file_type === 'pdf' && <FaRegFilePdf size='1.5rem' />
                      }
                      {
                        attachment.file_type === 'zip' && <GrDocumentZip size='1.5rem' />
                      }
                      {
                        attachment.file_type === 'mpeg' && <FaRegFileAudio size='1.5rem' />
                      }
                      {
                        attachment.file_type === 'vcard' && <FaRegAddressCard size='1.5rem' />
                      }
                      {
                        isVideoType(attachment.file_type) && <FaRegFileVideo size='1.5rem' />
                      }
                    </div>
                    <div
                      style={{ flex: "1" }}
                      className='d-flex flex-row flex-nowrap justify-content-between align-items-center'
                      onClick={() => (window.location.href = attachment.original_url)} >
                      <span
                        className='mr-2'
                        style={{ fontSize: "80%", wordBreak: "break-word" }} >
                        {`${attachment.file_name}.${attachment.file_type}`}
                      </span>
                      <IoMdDownload />
                    </div>
                  </button>
                )
              }
            })
          }
          {
            !props.isInternalDialogue && (
              <div className='d-flex flex-row justify-content-between' >
                <span
                  className='mr-2'
                  style={{ wordBreak: "break-word", whiteSpace: "pre-line" }} >
                  {props.message.content}
                </span>
                <span
                  style={{ fontSize: "70%", whiteSpace: "nowrap" }}
                  className='text-right d-flex align-items-end' >
                  {Moment(props.message.created_at).format('h:mm A')}
                </span>
              </div>
            )
          }
          {
            props.isInternalDialogue && (
              <span
                className='mr-2'
                style={{ wordBreak: "break-word", whiteSpace: "pre-line" }} >
                {props.message.content}
              </span>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default Message